import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { AdminBackgroundTaskStatus } from '../enums/admin-background-task-status';

@Injectable({
  providedIn: 'root',
})
export class BackgroundTaskStatusProviderService {
  private readonly entries = new Map<AdminBackgroundTaskStatus, string>([
    [AdminBackgroundTaskStatus.InProgress, 'W trakcie wykonania'],
    [AdminBackgroundTaskStatus.Done, 'Zakończone'],
  ]);

  public labelFor(status: AdminBackgroundTaskStatus): Observable<string> {
    const result = this.entries.get(status);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" is not found.`,
      );
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<AdminBackgroundTaskStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([status, label]) => new SelectItem<AdminBackgroundTaskStatus>(label, status),
      ),
    );
  }
}
